/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'Startsida',
	homePageTabsLabel: 'Heminnehåll',
	myContent: 'Mitt innehåll',
	teamContent: 'Teaminnehåll',
	folder: 'Mapp',
	files: 'Filer',
	actionMenu: 'Åtgärdsmeny',
	myFolder: 'Mina mappar',

	emptyFolderNoContent: 'Inget innehåll',

	//EmptyStates
	emptyRecentTitle: 'Du har inte tittat på något innehåll nyligen.',
	emptyStateTitle: 'Starta genom att lägga till data',
	emptyStateBody: 'Klicka på Överför data ovan eller dra och släpp för att överföra data.',
	emptySearchResultTitle: 'Din sökning returnerade inga resultat.',
	emptyPortalTitle: 'Inga portaler',
	emptyPortalBody: 'Du har för närvarande inga portaler.',
	emptyWsProjectTitle: 'Starta genom att skapa en anteckningsbok i Watson Studio.',
	emptyWsProjectBody: 'När du återgår till Cognos Analytics kommer din anteckningsbok att visas där.',
	emptyFilteredResultTitle: 'De tillämpade filtren returnerade inga resultat.',
	emptyDialogViewTitle: 'Inga artiklar',
	removeFromRecents: 'Ta bort från senaste',

	// Welcome Banner
	welcomeBannerGreeting: 'Hej! Välkommen till Cognos Analytics with Watson.',
	welcomeBannerDescription: 'Cognos Analytics with Watson-användare med AI-driven självbetjäningsanalys. Se hur automatiserad dataförberedelse, datainsamling och visualiseringar kan leda till säkrare beslut.',
	welcomeBannerDescription_trialUser: 'Du kan komma igång direkt genom att ta en titt på vår introduktionsvideo, produktrundtur och fliken Introduktion.',
	takeTourButtonLabel: 'Ta en produktrundtur',
	watchVideoButtonLabel: 'Se video',
	// confirmation dialog
	hideWelcomeBannerMsg: 'Vill du stänga av välkomstbanderollen på startsidan? Du kan sätta på den igen i Profil och inställningar > Inställningar > Allmänt när som helst. ',
	hideWelcomeBannerTitle: 'Stäng av välkomstbanderollen',
	ok: 'OK',
	cancel: 'Avbryt',
	warn: 'Varning',
	//howto video dialog
	modal_how_title: 'Se översikt över Cognos Analytics',
	modal_overview_title: 'Se översikt över Cognos Analytics',
	modal_how_play: 'Spela upp video',
	modal_how_video_title_overview: 'Översikt',
	modal_how_video_title_getStarted: 'Komma igång med 11.2',
	modal_how_video_title_newUI: 'Välkommen till nya Cognos',
	modal_how_video_title_dataModule: 'Översikt över datamoduler',
	modal_how_video_title_explore: 'Översikt över datautforskning',
	modal_how_video_title_dashboard: 'Översikt för interaktiva dashboards',
	modal_how_video_title_reporting: 'Rapporteringsöversikt',
	modal_how_video_title_mobile: 'Kraften hos Cognos i din hand',

	// Toolbar
	search: 'Sök',
	addFolder: 'Lägg till mapp',
	addLink: 'Lägg till länk',
	filter: 'Filtrera',
	sort: 'Sortera',
	settings: 'Inställningar',
	tilesView: 'Rutvy',
	listView: 'Listvy',
	columnView: 'Kolumnvy',
	backToSearch: 'Tillbaka till sökresultat',

	// Toolbar Actions
	sortBy: 'Sortera efter',
	sortOrder: 'Sortera',
	name: 'Namn',
	modifiedTime: 'Ändrad',
	type: 'Typ',
	ascending: 'Stigande',
	descending: 'Fallande',
	resetSort: 'Återställ sortering',

	filterType: 'Typ',
	filterModificationTime: 'Ändrad',
	all: 'Alla',
	today: 'I dag',
	yesterday: 'I går',
	pastWeek: 'Förra veckan',
	pastMonth: 'Förra månaden',
	resetFilters: 'Återställ filter',
	resultLimit: 'Resultatgräns',

	filterSearchPlaceHolder: 'Filtrera efter nyckelord',

	resetFilterTag: 'Klicka på X om du vill återställa filter.',
	filterTagToolTip: 'Tillämpade filter: %{appliedFilters}.',

	folderName: 'Mappnamn',
	addAFolder: 'Lägg till mapp',
	add: 'Lägg till',
	error: 'Fel',
	newFolderDefaultName: 'Ny mapp',
	toastCreateNewFolder: '%{nameOfFolder}-mappen skapades i %{tabName}.',
	folderAdded: 'Mappen lades till',
	refresh: 'Uppdatera',
	openFolder: 'Öppna mapp',

	addAUrl: 'Lägg till URL',
	linkName: 'URL-namn',
	linkNamePlaceholder: 'Lägg till URL-namn',
	linkDescription: 'Beskrivning (valfri)',
	linkDescriptionPlaceholder: 'Lägg till en beskrivning',
	linkUri: 'URL',
	linkUriPlaceholder: 'Lägg till en URL med en acceptabel domän',
	acceptableDomains: 'Acceptabla domäner',
	viewAcceptableDomains: 'Visa acceptabla domäner',
	mandatoryField: 'Obligatoriskt fält',
	linkAdded: 'URL lades till',
	toastCreateNewLink: '%{nameOfLink} lades till i %{tabName}.',
	noEntries: 'Det finns inga poster i listan över acceptabla domäner. Kontakta administratören.',
	unacceptableDomain: 'Din URL-adress använder en ogiltig domän. Klicka på Visa acceptabla domäner så visas en lista över domäner som du kan använda.',

	compact: 'Kompakt',
	short: 'Kort',
	default: 'Standard',
	rowSize: 'Radstorlek',

	// GroupyByTypes
	folders: 'Mappar',
	reports: 'Rapporter',
	dashboards: 'Kontrollpaneler',
	data: 'Data',
	packages: 'Paket',
	explorations: 'Utforskningar',
	stories: 'Berättelser',
	notebooks: 'Anteckningsböcker',
	others: 'Annat',

	// Error Messages
	itemsOverLimit: 'Namnet "%{itemName}" överskrider den maximala gränsen (20). Ange ett annat namn.',
	errorMessageLengthFolderName: 'Ange ett mappnamn som inte innehåller fler än 255 tecken.',
	errorMessageLengthLinkName: 'Ange ett länknamn som inte innehåller fler än 255 tecken.',
	toastLaunchPerspectiveError: 'Det går inte att öppna {objectType}.',
	errorNoAccessTitle: 'Du har inte åtkomst till det här innehållet',
	errorNoAccessBody: 'Kontakta administratören eller gå till följande länk:',
	errorEnableExternalContent: 'Aktivera externt innehåll',

	//TableHeader
	lastAccessed: 'Senast bearbetad',
	location: 'Plats',
	tenant: 'Innehavare',

	// GetStartedTab
	getStartedLabel: 'Kom igång med IBM Cognos Analytics',
	learningHowToLabel: 'Utbildningsresurser',
	learningHowToDescription: 'Utöka din kunskap och få hjälp genom att ansluta till gemenskapen, läsa dokumentation och se videor.',
	learningHowToActionLabel: 'Starta utbildningsrutan',
	howToVideosLabel: 'Instruktionsvideor',
	howToVideosDescription: 'Lär dig hur du använder IBM Cognos Analytics och få mer insikt i dina data.',
	howToVideosActionLabel: 'Se videor',
	acceleratorCatalogLabel: 'Accelerator-katalog',
	acceleratorCatalogDescription: 'Bläddra i en växande katalog över branschanvändning, guider för bästa praxis, anpassade visualiseringar och mer.',
	acceleratorCatalogActionLabel: 'Bläddra i katalog',
	sampleSectionTitle: 'Exempel',
	sampleSectionDescription: 'Experimentera med exempel som visar allt som Cognos Analytics har att erbjuda.',
	// Samples Section
	createDashboardSampleTitle: 'Hur du skapar din första kontrollpanel',
	createDashboardSampleDescription: 'Börja din resa i analyser med Cognos-kontrollpaneler.',
	nlaSampleTitle: 'Provrapport',
	nlaSampleDescription: 'Utforska vad som är möjligt med Cognos Analytics-rapporter med det här exemplet som analyserar kundkortsmedlemmars aktiviteter vid årsslutet.',
	sankeySampleTitle: 'Sankey',
	sankeySampleDescription: 'Utöka ditt visualiseringsbibliotek med anpassade visualiseringar som Sankey Chart.',
	viewAllSamplesActionLabel: 'Visa alla exempel',
	byFeatureTitle: 'Efter funktion',
	byFeatureDescription: 'Bläddra igenom exempel efter funktion, som kärnfunktionalitet, anpassade kontroller, utökningar, anteckningsböcker och relativa datum.',
	byIndustryTitle: 'Efter bransch',
	byIndustryDescription: 'Bläddra igenom exempel efter bransch, som fordon, bank med mera.',
	// SamplesTab
	sampleTabTitle: 'Få inspiration från våra färdiga exempel',
	sampleTabLabel: 'Gå till Acceleratorkatalogen för fler exempel och utökningar från IBM, partnerföretag och kunder',

	// quickLaunch
	quickLaunchLabel: 'Snabbstart',
	expand: 'Expandera',
	collapse: 'Komprimera',

	// quickLaunch dialog
	quickLaunchModalLabel: 'Börja med att välja vad du vill skapa.',

	// contentPageView
	contentPageTitleLabel: 'Innehåll',
	uploadFile: 'Överför data',
	new: 'Ny',
	create: 'Skapa',
	more: 'Fler',

	// open dialog
	selectDataSourcesToAdd: 'Välj datakällor att lägga till.',
	openDialogDefaultTitle: 'Öppna',

	// save dialog
	save: 'Spara',
	saveAs: 'Spara som',
	saving: 'Sparar...',
	selectedDestination: 'Vald destination: %{nameOfFolder}',
	toastDuplicateFileDifferentType: '\'%{nameOfItem}\' finns redan med en annan typ. Välj ett annat namn.',
	confirmOverwriteTitle: 'Bekräfta ersättning av befintliga data',
	confirmOverwriteMsg: 'Filen \'%{nameOfFile}\' finns redan. Vill du ersätta data med data i den valda filen?',

	// copy move dialog
	copy: 'Kopiera',
	move: 'Flytta',
	copyOrMove: 'Kopiera eller flytta: ',
	copyOnly: 'Kopiera ',
	createShortcut: 'Skapa genväg',
	createShortcutDialogTitle: 'Skapa genväg: ',

	// External asset types
	wsProject: 'Watson Studio-projekt',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'Paket',
	dataModule: 'Datamodul',
	exploration: 'Utforskning',
	mode: 'Läge',
	live: 'Live',
	snapshot: 'Statusbild',
	noSnapshotsFound: 'Ingen statusbild hittades',
	uploadedFile: 'Överförd fil',
	fileUpload: 'Överför data',
	dataSetEx: 'Datamängd',
	externalRepository: 'Extern behållare',
	queryMode: 'Frågeläge',
	queryModeCompatible: 'Kompatibelt',
	queryModeDynamic: 'Dynamiskt',
	report: 'Rapport',
	activeReport: 'Aktiv rapport',
	query: 'Fråga',
	analysis: 'Analys',
	dashboard: 'Kontrollpanel',
	dashboardTemplate: 'Kontrollpanelsmall',
	jupyterNotebook: 'Anteckningsbok',
	wsNotebook: 'Watson Studio-notebook',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'Berättelse',
	workspace: 'Arbetsyta',
	pagelet: 'Sida',
	content: 'Innehåll',
	directory: 'Namnrymder',
	dataSet: 'Datamängd',
	powerPlayCube: 'PowerPlay-kub',
	powerPlayReport: 'PowerPlay-rapport',
	powerPlay8Report: 'PowerPlay-rapport',
	setPowerPlay8ReportOptions: 'Ange alternativ för PowerPlay-rapport',
	powerPlay8ReportView: 'PowerPlay-rapportvy',
	reportTemplate: 'Rapportmall',
	packageConfigurations: 'Paketkonfiguration',
	agent: 'Agent',
	agentDefinition: 'Agentdefinition',
	agentDefinitionView: 'Agentvy',
	dataMovementTask: 'Dataflyttningsåtgärd',
	dataMovementTaskAlias: 'Alias för dataflyttningsåtgärd',
	document: 'Dokument',
	DocumentRetention: 'Dokumentegenskaper',
	jobDefinition: 'Jobbdefinition',
	job: 'Jobb',
	jobs: 'Jobb',
	metricsDataSourceETLTask: 'ETL-åtgärd för nyckeltalsdatakälla',
	metricsExportTask: 'Exportåtgärd för nyckeltal',
	metricsFileImportTask: 'Importåtgärd för nyckeltalsfil',
	metricsMaintenanceTask: 'Underhållsåtgärd för nyckeltal',
	planningTask: 'Planeringsåtgärd',
	shortcut: 'Genväg',
	shortcuts: 'Genvägar',
	URL: 'URL',
	launchable: 'Startbart',
	dataSetFolder: 'Datamängdsmapp',
	ViewAccessibleLabel: 'Visa %{label}',
	overrideReportOptions: 'Åsidosätt standardrapportvärdena',
	formats: 'Format',
	saveReport: 'Spara rapporten',
	reportView: 'Rapportvy',
	reportviews: 'Rapportvyer',
	html: 'HTML',
	pdf: 'PDF',
	spreadsheetML: 'Excel',
	xlsxData: 'Excel-data',
	csv: 'CSV',
	xml: 'XML',
	txt: 'TXT',
	role: 'Roll',
	namespace: 'Namnfält',
	namespaceFolder: 'Namnfältsmapp',
	adminFolder: 'Adminmapp',
	//Details
	details: 'Detaljer',
	open: 'Öppna',
	created: 'Skapades',
	modified: 'Ändrades',
	owner: 'Ägare',
	dataSource: 'Datakälla',
	share: 'Dela',
	addToFavorites: 'Lägg till i favoriter',
	properties: 'Egenskaper',
	detailsEmptyStateBody: 'Välj ett objekt för att visa detaljerna',
	editNameAndDescription: 'Redigera namn och beskrivning',
	none: 'Inget',
	setPdfOptions: 'Ange PDF-alternativ',
	runOptions: 'Körningsalternativ',

	//rename dialog
	nameInvalid: 'Namnet är ogiltigt',
	namePlaceholder: 'Ange ett namn',
	description: 'Beskrivning',
	descriptionInvalid: 'Beskrivningen får innehålla högst 350 tecken.',
	descriptionPlaceholder: 'Ange en beskrivning',
	errorMessageApostropheError: 'Ange ett filnamn som inte innehåller både \' och "',
	renameCollisionError: '%{name} finns redan. Välj ett annat namn.',
	unknownRenameError: 'Det gick inte att byta namn. Kontakta administratören om du behöver hjälp.',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: 'Det går inte att öppna mappen.',

	//Upload
	uploadToFolder: "Överför till <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction}",
	uploadAndLaunch: "Överför till <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> och starta%{launchAction}",
	quickUpload: "Snabböverföring",
	quickUploadAndLaunch: "Dra och släpp filer för att överföra till <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> och öppna i något av följande områden.",
	unsupportedFilesSingle: "%{files} överfördes inte eftersom den är ogiltig för snabbstart.",
	unsupportedFilesMultiple: "Filerna överfördes inte eftersom alla filer du väljer måste vara giltiga för att kunna använda Snabbstart.",
	unsupportedFilesSingleInvalid: "%{files} är ogiltig.",
	unsupportedFilesMultipleInvalid: "%{files} är ogiltiga.",
	supportedFileTypes: "Endast följande filtyper är tillåtna: %{extensions}.",
	uploadDragAndDrop: "Dra och släpp",
	uploadDragAndDropMessage: "Dra och släpp dina filer här för att överföra dem till <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>",

	// searchBar
	searchWasSaved: 'Sökkriteria \'%{searchTerm}\' sparades.',
	searchWasntSaved: 'Sökkriteria \'%{searchTerm}\' sparades inte.',
	searchSuggestions: 'Förslag',
	savedSearch: 'Sparade sökningar',
	searchWasDeleted: 'Sökkriteria \'%{searchTerm}\' togs bort.',
	searchWasntDeleted: 'Sökkriteria \'%{searchTerm}\' togs inte bort.',
	savedBarTitle: 'Sök i Cognos Analytics',
	searchContentPageTitle: 'Sök',
	searchContentPageTitleLabel: 'Visar resultat för \'%{searchTerm}\'',
	showingSearchRsult: 'Visar %{resultCount} objekt',
	saveSearch: 'Spara sökning',
	saveTenSearches: 'Du kan spara 10 sökningar.',
	deleteASearch: 'Ta bort en om du vill spara en annan.',
	close: 'Stäng',
	allContent: 'Allt innehåll',
	searchResultIn: 'Sök efter resultat i: ',
	//recent view
	recents: 'Senaste',
	noAccessRecent: 'Ingen åtkomst',
	noAccessRecentMsg: 'Du har inte åtkomst till den här resursen. Den kanske är avaktiverad eller borttagen, eller så kanske dina behörigheter har minskats. Kontrollera status för resursen på förväntad källplats. Du kan ta bort resursen från senaste objekt genom att klicka på OK.',
	noAccessMsg: 'Du har inte åtkomst till den här resursen. Den kanske är avaktiverad eller borttagen, eller så kanske dina behörigheter har minskats.',

	//contextToolbar
	itemsSelected: '%{nameOfSelection} objekt valda',
	itemSelected: '%{nameOfSelection} objekt valt',

	//properties
	general: 'Allmänt',
	schedule: 'Schema',
	permission: 'Behörigheter',
	capabilities: 'Funktioner',
	propertiesTabsLabel: 'Egenskapsinnehåll',
	searchPath: 'Sökväg',
	id: 'ID',
	language: 'Språk',
	setLanguage: 'Ange språk',
	entryOptions: 'Postalternativ',
	setPackage: 'Ange paket eller modul',
	sourcePackage: 'Källpaket eller datamodul',
	associatedSourceAgent: 'Källpaket',
	setAssociatedSourceAgent: 'Ange paket',
	sourceAgent: 'Källagent',
	setSourceAgent: 'Ange källagent',
	setCapabilities: 'Ange funktioner',
	disableEntry: 'Inaktivera den här posten',
	hideEntry: 'Dölj posten',
	permissions: 'Behörigheter',
	promptForValues: 'Fråga om värden',
	yes: 'Ja',
	no: 'Nej',
	setValues: 'Ange värden',
	moreOptions: 'Fler alternativ',
	reportFormat: 'Rapportformat',
	enableAccessibilitySupport: 'Aktivera tillgänglighetssupport',
	displayOfRunHistory: 'Visa körningshistorik',
	occurrences: 'Förekomster',
	days: 'Dag(ar)',
	months: 'Månad(er)',
	displayOfReportOutputVersions: 'Visning av rapportens utdataversion',
	defaultDisplayOfPortalAction: 'Standardportalåtgärd',
	viewMostRecentReport: 'Se den senaste rapporten',
	runTheReport: 'Kör rapporten',
	openWithReportStudio: 'Öppna i Report Studio',
	rowsPerPageInHtmlReports: 'Rader per sida i HTML-rapporter',
	enableSelectionBasedInteractivity: 'Aktivera urvalsbaserad interaktivitet',
	enableAlertsAboutNewVersions: 'Aktivera aviseringar om nya versioner',
	enableEnhancedUserFeaturesInSavedOutputVersions: 'Aktivera utökade användarfunktioner i sparade utdataversioner',
	enableCommentsInSavedOutputVersions: 'Aktivera kommentarer i sparade utdataversioner',
	run: 'Kör',
	runWithUsersCredentials: 'Med användarens inloggningsuppgifter',
	runWithOwnerCapabilities: 'Med ägarfunktioner',
	runAsOwner: 'Som %{ownerName}',
	actionLabelOn: 'På',
	actionLabelOff: 'Av',
	openReport: 'Redigera',
	openAnalysis: 'Öppna i Analysis Studio',
	openQuery: 'Öppna i Query Studio',
	openPowerPlay8Report: 'Öppna i PowerPlay Studio',
	openInteractiveReport: 'Redigera',
	read: 'Läs',
	write: 'Skriv',
	execute: 'Verkställ',
	setPolicy: 'Ange riktlinje',
	full: 'Fullständigt',
	traverse: 'Gå igenom',
	grant: 'Bevilja',
	deny: 'Neka',
	permissionCustom: 'Anpassad',
	permissionDetailsColumnAccess: 'Åtkomst',
	permissionDetailsColumnPermission: 'Behörighet',
	permissionDetailsColumnAction: 'Åtgärd',
	permissionSetAccess: 'Ange åtkomst',
	permissionRead: 'Läs',
	permissionRun: 'Kör',
	permissionWrite: 'Skriv',
	permissionFull: 'Fullständigt',
	unavailable: 'Ej tillgänglig',
	unkownSource: 'Okänd, öppna rapporten för detaljer',
	tenantSettings: 'Innehavarinställningar',
	tenantSet: 'Innehavare uppdaterades',
	tenantSetError: 'Fel vid definition av innehavare',
	tenantClear: 'Innehavare rensades',
	tenantClearError: 'Fel vid rensning av innehavare',
	shortcutTo: 'Genväg till',
	sourceReport: 'Källrapport',
	setSourceReport: 'Ange källrapport',
	setSourceLocation: 'Ange plats för källan %{itemName}',
	linkPackageOrModule: 'Länka %{itemName} till ett paket eller en datamodul',
	linkPackage: 'Länka %{itemName} till ett paket',
	externalRepositories: 'Externa datalager',
	sizeByte: '%{value} B',
	sizeKiloByte: '%{value} KB',
	sizeMegaByte: '%{value} MB',
	sizeGigaByte: '%{value} GB',
	sizeTeraByte: '%{value} TB',
	sizePetaByte: '%{value} PB',
	refreshedDatetime: 'Uppdaterades',
	size: 'Storlek',
	tenantsWarningMessage: 'Om du ändrar innehavare för en post ändras även innehavaren för underordnade objekt.',
	confirmClearTenantText: 'Om du rensar värdet får inga andra innehavare komma åt innehållet. Klicka på OK för att göra posten allmän eller Avbryt för att behålla aktuell innehavare.',
	confirmClearTenant: 'Bekräfta borttagning av innehavare',
	currentValues: 'Aktuella värden',
	emptyPromptValues: 'Det finns för närvarande inga värden',
	editValues: 'Redigera värden',
	clear: 'Rensa',
	source: 'Källa',
	dataRefreshed: 'Data uppdaterades',
	//PDF options
	pdfOptions: 'PDF-alternativ',
	set: 'Ange',
	portrait: 'Stående',
	landscape: 'Liggande',
	letter: 'Brev',
	legal: 'Rättslig',
	elevenxSeven: '11x17',
	A3: 'A3',
	A4: 'A4',
	b4jis: 'B4JIS',
	b5jis: 'B5JIS',
	orientation: 'Riktning',
	pageDefination: 'Pappersformat',
	openPasswordRequired: 'Kräv lösenord när rapporten öppnas',
	accessPasswordRequired: 'Kräv lösenord för att få åtkomst till rapporten',
	emptyPassword: 'Lösenord kan inte lämnas tomt',
	password: 'Lösenord',
	enterPassword: 'Ange lösenord',
	confirmPassword: 'Bekräfta lösenord',
	passwordMatchError: 'Lösenorden matchar inte',
	gateway: 'Gateway',
	pageLayout: 'Sidlayout',
	pageStyle: 'Stil',
	setUrl: 'Ange webbadress',
	numberRows: 'Antal rader',
	numberColumns: 'Antal kolumner',
	timeToRefresh: 'Tid att uppdatera',
	lastRefreshedBy: 'Uppdaterades av',
	unknown: 'Okänd',
	unknownUpdateError: 'Objektuppdateringen misslyckades. Kontakta administratören om du behöver hjälp.',
	editQuery: 'Redigera fråga',
	greaterOrEqual: 'Större än eller lika med %{upperboundValue}',
	lessOrEqual: 'Mindre än eller lika med %{lowerboundValue}'
});
